import scrollLock from './functions/_scrollLock.js' // スクロールロック

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言

if (document.getElementById('page-tokuyo')) {
  pageTokuyo()
}

function pageTokuyo() {
  //  ###    ###   #####   ####      ###    ##
  //  ## #  # ##  ##   ##  ##  ##   ## ##   ##
  //  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
  //  ##      ##  ##   ##  ##  ##  #######  ##
  //  ##      ##   #####   ####    ##   ##  ######

  const modalOverlay = document.getElementById('modalOverlay') // モーダル用オーバーレイ
  const modals = document.getElementsByClassName('js-modal') // モーダル本体
  if (modals[0]) {
    window.addEventListener('click', (e) => {
      if (!e.target.closest('.js-modal-open')) {
        return
      }
      e.preventDefault()
      modalClose()
      const target = e.target.closest('.js-modal-open').dataset.modal

      const openModals = document.querySelectorAll('.js-modal--' + target)
      for (const openModal of openModals) {
        openModal.classList.add('active')
      }

      modalOverlay.classList.add('active')
      scrollLock('body', '#modalOverlay')
    })
    // モーダル撤去
    window.addEventListener('click', (e) => {
      if (!e.target.closest('.js-modal-close')) {
        return
      }
      e.preventDefault()
      modalClose()
      modalOverlay.classList.remove('active')
      scrollLock('body', '#modalOverlay')
    })
  }

  function modalClose() {
    // モーダルを消す
    for (let index = 0; index < modals.length; index++) {
      const modal = modals[index]
      modal.classList.remove('active')
    }
  }

  /*
 ######## ######## ##     ## ########         ######## ##     ##
    ##    ##         ## ##      ##            ##         ## ##
    ##    ######      ###       ##    ####### ######      ###
    ##    ##         ## ##      ##            ##         ## ##
    ##    ######## ##     ##    ##            ######## ##     ##
クリックでテキストを開閉
*/
  const textExpand = document.getElementsByClassName('js-textExpand')
  if (textExpand[0]) {
    window.addEventListener('click', function (e) {
      // 指定のクラスを持つ
      if (!e.target.classList.contains('js-textExpand')) {
        return
      }
      const target = e.target.dataset.target

      const expandTarget = document.getElementsByClassName('js-textExpand--' + target)

      for (const iterator of expandTarget) {
        iterator.classList.toggle('active')
      }
    })

    // 高さをチェックし、想定より低い場合は開閉機構を省略する
    for (const expandBtn of textExpand) {
      const target = expandBtn.dataset.target

      // 表示デバイスに対する基準の高さを取得
      let border = 0
      if (window.matchMedia('(min-width:769px)').matches) {
        border = expandBtn.dataset.borderPc
      } else {
        border = expandBtn.dataset.borderSp
      }

      const expandTarget = document.getElementsByClassName('js-textExpand--' + target)
      for (const iterator of expandTarget) {
        if (iterator.offsetHeight < border) {
          iterator.classList.add('active')
          iterator.classList.add('full')
          expandBtn.style.display = 'none'
        }
      }
    }
  }

  //   ####  ##      ##  ####    #####
  //  ##     ##      ##  ##  ##  ##
  //   ###   ##      ##  ##  ##  #####
  //     ##  ##      ##  ##  ##  ##
  //  ####   ######  ##  ####    #####

  let tokuyoHealthImgSwiper
  if (document.getElementById('tokuyoHealthImg')) {
    // SP時だけスライダーにする
    if (window.matchMedia('(max-width:768px)').matches) {
      tokuyoHealthImgSwiperInit()
    }
    window.addEventListener('resize', function (e) {
      if (tokuyoHealthImgSwiper && window.matchMedia('(min-width:769px)').matches) {
        tokuyoHealthImgSwiper.destroy()
        tokuyoHealthImgSwiper = false
      } else if (!tokuyoHealthImgSwiper && window.matchMedia('(max-width:768px)').matches) {
        tokuyoHealthImgSwiperInit()
      }
    })
  }
  function tokuyoHealthImgSwiperInit() {
    const slideItem = document.getElementById('tokuyoHealthImg')
    const sliderName = 'tokuyoHealthImg'
    tokuyoHealthImgSwiper = new Swiper(slideItem, {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 1.2, //表示数変更
      spaceBetween: 15, //スライド同士の間隔を空ける
      centeredSlides: true, // 中央のスライドを基準にする
      autoHeight: true, // スライドごとに高さを変動させる
      autoplay: {
        // オートオプション
        delay: 5000, // 待機時間
        disableOnInteraction: false, // 操作されたらオート解除
      },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
      },

      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },

      breakpoints: {
        // 指定px以上でオプション切り替え
        769: {},
      },
    })
  }
}
